import { render } from "./ylyUploadVideo.vue?vue&type=template&id=273139c9&scoped=true"
import script from "./ylyUploadVideo.vue?vue&type=script&lang=js"
export * from "./ylyUploadVideo.vue?vue&type=script&lang=js"

import "./ylyUploadVideo.vue?vue&type=style&index=0&id=273139c9&lang=scss&scoped=true"

import exportComponent from "D:\\work\\qianduan\\operation-system\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-273139c9"]])

export default __exports__